import React from 'react';
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from '@nextui-org/react';
import { Trash2 } from 'lucide-react';

interface ConfirmDeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  isLoading?: boolean;
}

/**
 * Lösch-Bestätigungsdialog (Port des AlertDialogs aus
 * forum_topic_view.dart der Flutter-App).
 */
const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  isLoading = false,
}) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    classNames={{
      base: 'bg-zinc-900 border border-zinc-800 text-white',
      closeButton: 'text-gray-400 hover:bg-zinc-800',
    }}
  >
    <ModalContent>
      <ModalHeader className="flex items-center gap-2">
        <Trash2 size={18} className="text-red-500" />
        {title}
      </ModalHeader>
      <ModalBody>
        <p className="text-gray-400 text-sm">{message}</p>
      </ModalBody>
      <ModalFooter>
        <Button
          variant="flat"
          className="bg-zinc-800 text-gray-300"
          onPress={onClose}
          isDisabled={isLoading}
        >
          Abbrechen
        </Button>
        <Button
          color="danger"
          onPress={onConfirm}
          isLoading={isLoading}
        >
          Löschen
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);

export default ConfirmDeleteModal;
